import { render, staticRenderFns } from "./PwaInstallButton.vue?vue&type=template&id=1008333c&scoped=true"
import script from "./PwaInstallButton.vue?vue&type=script&lang=js"
export * from "./PwaInstallButton.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallButton.vue?vue&type=style&index=0&id=1008333c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008333c",
  null
  
)

export default component.exports